/*
 * @Author: wangyu
 * @since: 2023-08-29 16:15:26
 * @lastTime: 2023-08-29 16:15:26
 * @LastEditors: huangfuchunmei
 * @message: 联调窗口
 */
import React, { useState, useRef } from "react";
import styles from "./index.module.scss";
import { Modal} from '@arco-design/web-react';
const supportChat = require("../../assets/support_chat.png")
import { Form, Input, Checkbox, Message, Button } from '@arco-design/web-react';
import PrivacyClause from "../../contactSupport/components/PrivacyClause";
import request from '@/common/request'
import { DOMAIN_API, PRIVACY} from '@/common/const';
import LazyMedia from "@/components/LazyMedia"

const FormItem = Form.Item;
interface IProps {
    ctry: string;
    words: Record<string, string>;
    visibleChat: boolean; // 聊天窗口
    setVisibleChat: any;
}
const chatWindowModal = (props:IProps) => {
    const {visibleChat, setVisibleChat, ctry, words } = props
    const [visible, setVisible] = React.useState(false); // 隐私条款弹窗 是否可见
    const [privacyList, setPrivacyList] =  useState(''); // 隐私条款
    // 处理单选框
    const options = [words?.support_chart_window_statement_read];
    const [valueOptions, setValueOptions] = useState([0, 1]);
    // 表单校验
    const formRef = useRef<any>();
    const formRule = {
        nickname: [{ required: true, message: `${words?.support_chart_window_nickname_input}` }],
        agree: [{ required: true, message: `${words?.support_email_us_select + ' ' + words?.support_chart_window_statement_read}` }]
    }

    // 获取隐私条款
    const getList = (ctry: string) => {
        request.post(`${DOMAIN_API}/o/official/content/getContentList`, {
            contentTypeId: PRIVACY,
            stationCode: ctry,
        })
        .then(res => {
            const records = res.data.data[0].detail
            setPrivacyList(records)
        })
        .catch(err => {
            console.log(err)
        })
    }

    // 调起实际聊天窗口
    const submit = () => {
        formRef.current?.validate().then((values: any) => {
          setVisibleChat(false)
          const _Window = window as any
          _Window.OpenContactUs && _Window.OpenContactUs();
        }).catch((err: string) => {
            console.log(err)
        })
    }

    // 弹出隐私条款
    const privacyClauseShow = () => {
        getList(ctry)
        setVisible(true)
    }

    // 聊天窗口同意
    const privacyClauseAgree = () => {
        setVisible(false)
        formRef.current.setFieldsValue({ agree: [0] })
    }

    return (
        <>
            <Modal
                className={styles['chat_modal']}
                title={words.support_chart_window_title}
                visible={visibleChat}
                onOk={() => {
                    setVisibleChat(false);
                }}
                okText={words.support_email_us_agree}
                autoFocus={false}
                focusLock={true}
                onCancel={() => {
                    setVisibleChat(false);
                }}
                footer={
                    <>
                        <button onClick={submit}>{words.support_chart_window_chat}</button>
                    </>
                }
            >
                <LazyMedia type="image" src={supportChat} />
                <p>
                    <span> {words?.support_chart_window_content}</span>
                    <span className={styles['privacy_btn']} onClick={privacyClauseShow}>{words?.support_chart_window_privacy}</span>
                </p>
                <Form ref={formRef} autoComplete="off" layout="vertical" className={styles['contact-form']}>
                    <FormItem label={`${words?.support_chart_window_nickname}`} field='nickname' rules={formRule.nickname}>
                        <Input placeholder={`${words?.support_chart_window_nickname_input}`} />
                        {/* SN */}
                    </FormItem>
                    <FormItem label={`${words?.support_chart_window_statement}`} field='agree' rules={formRule.agree}>
                        {/*<Checkbox>{words?.support_chart_window_statement_read}</Checkbox>*/}
                        <Checkbox.Group
                            value={valueOptions}
                            options={options.map((x, i) => ({
                                label: x,
                                value: i,
                            }))}
                        />
                    </FormItem>
                </Form>
            </Modal>
            {/* 隐私条款弹出框 */}
            <PrivacyClause privacyList={privacyList} ctry={ctry} words={words} visible={visible} setVisible={setVisible} privacyClauseAgree={privacyClauseAgree} />
        </>
    )
}
export default chatWindowModal
